import React from 'react';
import { Code, Shield, Zap, Users } from 'lucide-react';

const categories = [
  {
    title: "Page Layouts",
    examples: ["Single Page", "Multi-Column", "Landing Page"],
    description: "Responsive layouts that adapt to any screen size."
  },
  {
    title: "Form Components",
    examples: ["Contact Forms", "Sign Up Forms", "Surveys"],
    description: "Accessible forms with proper validation structure."
  },
  {
    title: "Navigation Elements",
    examples: ["Header Nav", "Sidebar Menu", "Footer Links"],
    description: "User-friendly navigation components."
  }
];

const tips = [
  {
    icon: Code,
    title: "Semantic HTML",
    content: "Use meaningful tags that describe your content."
  },
  {
    icon: Shield,
    title: "Accessibility",
    content: "Ensure your code is accessible to all users."
  },
  {
    icon: Zap,
    title: "Performance",
    content: "Write clean, optimized code for better performance."
  },
  {
    icon: Users,
    title: "User Experience",
    content: "Create intuitive and user-friendly structures."
  }
];

export default function HTMLGuide() {
  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to HTML Generation
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-blue-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Best Practices for HTML Code
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 mb-4">
                  <tip.icon className="w-6 h-6 text-blue-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}